import type { OurStages } from "@hz/common/constants";
import { withSentryReactRouterV6Routing } from "@sentry/react";

import { Navigate, Route, Routes } from "react-router-dom";

import { PrivateRoute } from "@components/private-route";

import InitPage from "@compositions/init";
import MappingsPage from "@compositions/mappings";
import OnboardingPage from "@compositions/onboarding";
import ReconnectPage from "@compositions/reconnect";
import SettingsPage from "@compositions/settings";
import ConnectionsPage from "@compositions/settings/connections";
import ContactPage from "@compositions/settings/contact";
import TroubleshootPage from "@compositions/settings/troubleshoot";
import SubscribePage from "@compositions/subscribe";
// import MappingsPage from "@compositions/mappings";

type RouterProps = {
  hasPaidSubscription: boolean;
  isTrial: boolean;
  isActive: boolean;
  stage: OurStages;
};

const Router = withSentryReactRouterV6Routing(({ isActive }: RouterProps) => (
  <Routes>
    <Route element={<PrivateRoute isActive={isActive} />}>
      <Route
        path="/"
        element={<InitPage />}
      />
      <Route
        path="/settings"
        element={<SettingsPage />}
      >
        <Route
          index
          element={
            <Navigate
              to="/settings/connections"
              replace
            />
          }
        />
        <Route
          path="connections"
          element={<ConnectionsPage />}
        />

        <Route
          path="contact"
          element={<ContactPage />}
        />

        <Route
          path="troubleshoot"
          element={<TroubleshootPage />}
        />
      </Route>

      <Route
        path="/mappings"
        element={<MappingsPage />}
      />

      <Route
        path="/onboarding"
        element={<OnboardingPage />}
      />

      <Route
        path="/reconnect"
        element={
          <ReconnectPage
            isGoogleConnected={false}
            isMondayConnected={true}
          />
        }
      />
    </Route>

    {!isActive ? (
      <Route
        path="/subscribe"
        element={<SubscribePage />}
      />
    ) : (
      <Route
        path="/subscribe"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />
    )}
  </Routes>
));

export default Router;
